function resolveProfilePic(user) {
  if (!user.profile_picture_url)
    return require("@/assets/default-profile-pic.jpg");
  return user.profile_picture_url;
}

export { resolveProfilePic };
